import { getFileSourceTypeRestrictionsRemote } from '@flex-apis/recruiting';
import { useQueryFromRemote } from '@flex-packages/remote-hooks';

function useGetFileSourceTypeRestrictionsRemote(requestParams, options) {
  return useQueryFromRemote({
    remote: getFileSourceTypeRestrictionsRemote,
    extraParams: requestParams,
    options
  });
}

export { useGetFileSourceTypeRestrictionsRemote };
//# sourceMappingURL=useGetFileSourceTypeRestrictionsRemote.mjs.map
